import React, { forwardRef } from 'react';

import type { MenuItemProps } from '@mui/material';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  label: {
    color: theme.appColors.iconsType,
    flexGrow: 1,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
  },
  listIcon: {
    color: theme.appColors.iconsType,
    minWidth: 32,
  },
  shortCutKey: {
    color: theme.appColors.secondaryType,
    fontSize: 14,
    marginLeft: theme.spacing(3),
  },
}));

interface BaseMenuOptionProps extends Omit<MenuItemProps, 'button'> {
  label: string;
  disableIcon?: boolean;
  icon?: React.ReactNode;
  shortCutKey?: string;
}

// Forward ref required for Material UI
export const BaseMenuOption = forwardRef(function BaseMenuOption(
  props: BaseMenuOptionProps,
  ref: React.Ref<HTMLLIElement> | null
): JSX.Element {
  const { children, disableIcon, icon, label, shortCutKey, ...rest } = props;
  const { classes } = useStyles();

  function generateChildren(): React.ReactNode | null {
    if (!shortCutKey && !children) return null;
    else if (shortCutKey)
      return <Typography className={classes.shortCutKey}>{shortCutKey}</Typography>;
    else if (children) return children;
  }

  function generateIcon(): JSX.Element | null {
    if (disableIcon) return null;

    if (icon) return <ListItemIcon className={classes.listIcon}>{icon}</ListItemIcon>;

    return (
      <ListItemIcon className={classes.listIcon}>
        <div />
      </ListItemIcon>
    );
  }

  const iconContent = generateIcon();
  const contents = generateChildren();

  return (
    <MenuItem ref={ref} {...rest}>
      {iconContent}
      <Typography className={classes.label}>{label}</Typography>
      {contents}
    </MenuItem>
  );
});
